import { AccountCardInteractive } from '../../../widgets/account-card-interactive';
import { Card, CardContent } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';
import type { Account } from '../../../entities/account';

interface AccountsListProps {
  accounts: Account[];
}

/**
 * Заглушка на время загрузки: повторяет геометрию AccountCard —
 * аватар 12, две строки текста, ряд тэгов. Без неё на секунду показывался
 * экран «Нет подключенных аккаунтов».
 */
export function AccountsListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }, (_, i) => (
        <Card key={i}>
          <CardContent className="space-y-3 p-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-12 w-12 shrink-0 rounded-full" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
            <div className="flex gap-1.5">
              <Skeleton className="h-5 w-14 rounded-full" />
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export function AccountsList({ accounts }: AccountsListProps) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {accounts.map((account) => (
        <AccountCardInteractive key={account.id} account={account} />
      ))}
    </div>
  );
}